import { Column } from '@synqo/frontend-component-library';
import { ApiVat } from '@Model';

export const vatColumns: Column<ApiVat>[] = [
    { name: 'label', label: 'Bezeichnung' },
    { name: 'shorthand', label: 'Suchcode' },
    { name: 'rate', label: 'MWSt.-Satz' },
    { name: 'code', label: 'Code' },
];
